import cpt_text_option from './cpt-text-option'
let op = JSON.parse(JSON.stringify(cpt_text_option))

op.cptDataForm.dataText = '{"value":"合计"}'
op.cptDataForm.datasetName = []
op.cptDataForm.functionVariable = []
op.attribute.functionResult = {function: '',result: ''}

export default op